import {useEffect, useState} from 'react'
import {Button, Checkbox, Popconfirm, Popover, Spin} from 'antd'
import React from 'react'
import {useIntl} from 'react-intl'
import {DatabasePlantRecord, instance as plantsService} from '../../services/PlantsService'
import {DeleteOutlined, EditOutlined} from '@ant-design/icons'
import {
  PlantDatabaseSearchField,
  PlantDatabaseSearchFieldWithConfirm,
} from './PlantDatabaseSearchField'
import './basePlantSelector.less'

export type BasePlantSelectorProps = {
  basePlantId?: string
  onBasePlantSelected: (
    basePlant: DatabasePlantRecord | null,
    fieldsToClear: Partial<DatabasePlantRecord['fields']>,
    titlePhoto: string
  ) => void
}

export function BasePlantSelector({basePlantId, onBasePlantSelected}: BasePlantSelectorProps) {
  const [selectedBasePlant, setSelectedBasePlant] = useState<DatabasePlantRecord | null>(null)
  const [isLoading, setLoading] = useState(Boolean(basePlantId))
  const [isSelectorVisible, setSelectorVisible] = useState(false)
  const [clearBaseFieldsChecked, setClearBaseFieldsChecked] = useState(false)

  const intl = useIntl()

  useEffect(() => {
    if (!basePlantId) {
      setSelectedBasePlant(null)
      return
    }

    ;(async () => {
      try {
        const initialPlant = await plantsService.getPlantFromPlantDatabaseById(basePlantId)
        if (initialPlant.status === 'found') {
          setSelectedBasePlant(initialPlant.data)
        }
      } finally {
        setLoading(false)
      }
    })()
  }, [basePlantId])

  // <div>{intl.formatMessage({id: 'searchingPlantBase'})}</div>
  //     <PlantDatabaseSearchField
  //       initialSelectedPlantId={currentPlant.plantBaseId}
  //       onDBPlantSelected={(p) => {
  //         setSearchSelectedBasePlant(p)
  //       }}
  //     />

  if (isLoading) {
    return <Spin />
  }

  const renderBasePlantSelectPopover = (content) => (
    <Popover
      destroyTooltipOnHide
      classNames={{root: 'baseplant-popover'}}
      content={
        <PlantDatabaseSearchFieldWithConfirm
          selectButtonText={
            selectedBasePlant
              ? intl.formatMessage({id: 'overwriteBasePlant'})
              : intl.formatMessage({id: 'select'})
          }
          onDBPlantSelected={(plant) => {
            setSelectorVisible(false)
            onBasePlantSelected(
              plant,
              selectedBasePlant ? selectedBasePlant?.fields || {} : {},
              plant.thumbnailUrl
            )
          }}
        />
      }
      trigger="click"
      open={isSelectorVisible}
      onOpenChange={setSelectorVisible}
      placement="bottom"
    >
      {content}
    </Popover>
  )

  if (!selectedBasePlant) {
    return renderBasePlantSelectPopover(
      <Button className="baseplant-add-button">
        {intl.formatMessage({id: 'addFromPlantDatabase'})}
      </Button>
    )
  }

  return (
    <div>
      <div>
        {intl.formatMessage({id: 'nowUsingBasePlant'})}:{' '}
        <strong style={{marginRight: 10}}>
          {selectedBasePlant.fields['Общераспространенное название']}
          {selectedBasePlant.fields['Сорт_eng'] || selectedBasePlant.fields['Сорт_ru']
            ? ` ${selectedBasePlant.fields['Сорт_eng']}`
              ? ` ${selectedBasePlant.fields['Сорт_eng']}`
              : ` ${selectedBasePlant.fields['Сорт_ru']}`
            : ''}
        </strong>
        <Button.Group size="small" className="baseplant-edit-button-group">
          {renderBasePlantSelectPopover(
            <Button icon={<EditOutlined />}>{intl.formatMessage({id: 'changeBasePlant'})}</Button>
          )}
          <Popconfirm
            title={`${intl.formatMessage({id: 'confirmClearBasePlant'})}?`}
            onOpenChange={() => setClearBaseFieldsChecked(false)}
            onConfirm={() =>
              onBasePlantSelected(
                null,
                clearBaseFieldsChecked ? selectedBasePlant?.fields || {} : {},
                null
              )
            }
            description={
              <div>
                <Checkbox
                  checked={clearBaseFieldsChecked}
                  onChange={(e) => setClearBaseFieldsChecked(e.target.checked)}
                >
                  {intl.formatMessage({id: 'clearBasePlantMatchingFields'})}?
                </Checkbox>
              </div>
            }
          >
            <Button danger icon={<DeleteOutlined />}>
              {intl.formatMessage({id: 'clearBasePlant'})}
            </Button>
          </Popconfirm>
        </Button.Group>
      </div>
    </div>
  )
}
